import { Sustainability } from '@travel/icons/service';
import cx from '@travel/ui/utils/classnames';

import styles from './sustainabilityLabel.module.scss';

type Props = {
  className?: string;
};

const SustainabilityLabel = ({ className = '' }: Props) => {
  return (
    <div className={cx(styles.sustainabilityLabel, className)}>
      <Sustainability size={14} className={styles.sustainabilityIcon} />
      <span className={styles.sustainabilityText}>サステナブルトラベル</span>
    </div>
  );
};

export default SustainabilityLabel;
